import styled from '@emotion/styled';
import React from 'react';
import {
    IReworkReason,
    IReworkReasonStage,
    IReworkReasonTopic,
} from '@Data/qualityControl/Interfaces';
import { ReworkColumn } from './ManageReworkDialog';
import { ReworkOptionColumn } from './ReworkOptionColumn';

interface IReworkOptionGridProps {
    selectedColumn: ReworkColumn;
    onSelectColumn: (column: ReworkColumn) => void;
    stages: IReworkReasonStage[];
    selectedReason: IReworkReason;
    onSelectReason: (r: IReworkReason) => void;
    selectedStage: IReworkReasonStage;
    onSelectStage: (s: IReworkReasonStage) => void;
    selectedTopic: IReworkReasonTopic;
    onSelectTopic: (t: IReworkReasonTopic) => void;
}

function getColumns(selectedColumn: ReworkColumn): string {
    switch (selectedColumn) {
        case 'stage':
            return 'minmax(0,2fr) minmax(0,0.5fr) minmax(0,0.5fr)';
        case 'topic':
            return 'minmax(0,0.5fr) minmax(0,2fr) minmax(0,0.5fr)';
        case 'reason':
            return 'minmax(0,0.5fr) minmax(0,0.5fr) minmax(0,2fr) ';
        default:
            return '1fr 1fr 1fr';
    }
}

const StyledGrid = styled('div')<{ $selectedColumn }>(
    ({ $selectedColumn }) => `
    display: grid;
    grid-template-columns: ${getColumns($selectedColumn)};
    column-gap: 4px;
    transition-property: all;
    transition-duration: 500ms;   
    overflow: hidden;
`
);

export const ReworkOptionGrid = (props: IReworkOptionGridProps) => {
    return (
        <StyledGrid $selectedColumn={props.selectedColumn}>
            <ReworkOptionColumn
                title="Stage"
                onSelect={() => props.onSelectColumn('stage')}
                options={props.stages}
                onSelectOption={(status) => props.onSelectStage(status)}
                selectedOption={props.selectedStage}
            />
            <ReworkOptionColumn
                title="Topic"
                onSelect={() => props.onSelectColumn('topic')}
                options={props.selectedStage?.topics}
                onSelectOption={(topic) => props.onSelectTopic(topic)}
                selectedOption={props.selectedTopic}
            />
            <ReworkOptionColumn
                title="Reason"
                onSelect={() => props.onSelectColumn('reason')}
                options={props.selectedTopic?.reasons}
                onSelectOption={(reason) => props.onSelectReason(reason)}
                selectedOption={props.selectedReason}
            />
        </StyledGrid>
    );
};
